import { render, staticRenderFns } from "./HotelsModule.vue?vue&type=template&id=7f0702c4&scoped=true"
import script from "./HotelsModule.vue?vue&type=script&lang=js"
export * from "./HotelsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0702c4",
  null
  
)

export default component.exports